<template>
  <div >
    <div class="h-topbar">
      <topbar></topbar>
    </div>

  



   <div class="messageBox">
    <p class="p-title pT">账号信息</p> 
    <div class="messageBoxc" >
      <div class="messageBoxcV">
        <div class="messageBoxcVL">
          <div class="messageBoxcVLc">
            <div class="messageBoxcVLcl">
              <img src="../assets/headimg.png">
            </div>
            <div  class="messageBoxcVLcr">
              <div style="font-size: 16px;">{{userName}}</div>
              <div style="font-size: 14px;">角色:{{roles}}</div>
            </div>
            
          </div>
          
        </div>
        <div class="messageBoxcVR" style="">
          <!--h-button type="primary" icon="add" @click="showadd(1)">修改个人信息</h-button-->
        </div>
      </div>
      <!--div style="overflow: hidden;border-top:1px solid #DCE1E7;padding-top:10px;">
        <div style="float: left;width: 50%;text-align: left;font-size: 20px;padding-left:20px;">
          ISV <span>浙江鲸腾网络科技有限公司</span>
        </div>
        <div style="float: left;width: 50%;text-align: right;">
          <h-button type="primary" icon="add" @click="showadd(1)">修改开发商信息</h-button>
        </div>
        
      </div-->
      
    </div>
    <p class="p-title pT" style="margin-top:10px;">我的活动列表</p> 
    <h-row class-name="filter-box" type="flex" justify="space-between">
      <h-col span="24" style="text-align: left;">
        <h-button type="primary" icon="add" @click="showadd(1)">创建活动</h-button>
      </h-col>
    </h-row>
    <h-row>
      <h-col span="24">
        <h-table highlight-row :columns="columns" :data="objectList"
                 :loading="loading" ></h-table>
        <h-page style="margin: 10px 0;text-align: right;" :total="pageInfo.total" @on-change="dataChange" :current="pageInfo.pageNo"
                :page-size="pageInfo.pageSize" @on-page-size-change="onPageSizeChange"
                show-elevator show-total show-sizer :page-size-opts="[5, 10, 20, 50]"></h-page>
      </h-col>
    </h-row>
    <div v-if="popshow">
 <!--     <img src="../assets/workflow.png"> -->
    </div>
   </div>

    <!--表单-->
    <h-msg-box v-model="editVisable">
      <p slot="header">
        <span v-html="editForm.id ? '修改活动' : '新增活动'"></span>
      </p>
      <h-form ref="editFormBox" style="margin: 0 10px"
              :model="editForm"
              :label-width="100"
              :rules="editRules">
         <h-form-item  v-if="editForm.id" label="活动编号" prop="activityNo" required>
          <h-input v-model="editForm.activityNo" disabled></h-input>
        </h-form-item> 
        <h-form-item v-if="editForm.id" label="活动ID" prop="uuid" required>
          <h-input v-model="editForm.uuid" disabled></h-input>
        </h-form-item>      


        <h-form-item label="活动名称" prop="activityName" required>
          <h-input v-model="editForm.activityName"></h-input>
        </h-form-item>
       

        <h-form-item label="开始时间" prop="activityBeginTime" required>
          <h-date-picker type="datetime" placeholder="选择开始时间" style="width: 336px"
                         v-model="editForm.activityBeginTime"></h-date-picker>
        </h-form-item>
        <h-form-item label="结束时间" prop="activityEndTime" required>
          <h-date-picker type="datetime" placeholder="选择结束时间" style="width: 336px"
                         v-model="editForm.activityEndTime"></h-date-picker>
        </h-form-item>

        <h-form-item v-if="editForm.id" label="活动状态" prop="activityStatus" required>
          <h-simple-select placeholder="请选择" filterable :clearable="true" v-model="editForm.activityStatus">
            <h-select-block :data="this.activityStatuss"></h-select-block>
          </h-simple-select>
        </h-form-item>

      </h-form>
      <div slot="footer">
        <h-button type="primary" @click="submitAddorEdit()">保存</h-button>
        <h-button @click="editVisable = false">关闭</h-button>
        
      </div>
    </h-msg-box>


  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import LockScreen from '@/components/LockScreen'
import Topbar from '@/views/frame/Topbar'
import { changePwd, initMsg } from '@/api/login'
import fetch from '@/api/httpFetch.js'
import { allToggleClass } from '@/utils'
import {formatDateTime} from '@/utils';
 import {queryActivity,removeActivity,addActivity,editActivity,judgeobj,showmenu} from "@/api/bizApi/commonUtil";
// import secret from '../../../secret/secret.js'
export default {
  data() {

    //校验活动名称
      const validateTName = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入活动名称'));
        } else {
          if (value.length > 30) {
            callback(new Error('活动名称长度不能超过30个字'));
            return;
          }
          callback();
        }
      };
      //校验活动预发布码
      const validatePreCode = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入活动预发布码'));
        } else {
          if (value.length > 10) {
            callback(new Error('活动预发布码长度不能超过10个字'));
            return;
          }
          //去后台校验唯一性
          let data = {
            id: this.editForm.id,//新增或编辑
            attributeName: 'pre_release_code',
            attributeValue: value
          }

          fetch.post('/activity/checkAttributesValueExist', data).then(res => {
            if (!res.data.errcode === '0') {
              callback(new Error('检查活动预发布码异常'));
            } else {
              if (!res.data.data) {
                callback(new Error('活动预发布已存在!'))
              } else {
                callback();
              }

            }
          })
        }

      };


      //校验活动Key
      const validateTKey = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入活动Key'));
        } else {
          if (value.length > 10) {
            callback(new Error('活动Key长度不能超过10个字'));
            return;
          }
          //去后台校验唯一性
          let data = {
            id: this.editForm.id||'',//新增或编辑
            attributeName: 'activity_no',
            attributeValue: value
          }

          fetch.post('/activity/checkAttributesValueExist', data).then(res => {
            if (!res.data.errcode === '0') {
              callback(new Error('检查模板KEY异常'));
            } else {
              if (!res.data.data) {
                callback(new Error('模板Key已存在!'))
              } else {
                callback();
              }

            }
          })
        }

      };
      const activityEndTimeCode=(rule, value, callback) => {
        let activityBeginTime='';
        let valueE='';

        if (value === '') {
          callback(new Error('请输入活动结束时间'));
        } else {
          if(this.editForm.activityBeginTime){
             activityBeginTime=(this.editForm.activityBeginTime).getTime();
          }
          if(value){
            valueE=value.getTime();
          }
          if(activityBeginTime>valueE){
            callback(new Error('活动结束时间大于活动开始时间'));
          }else{
            callback();
          }
        }
      };
      let columns = [
        {
          title: '活动编号',
          width: 80,
          key: 'activityNo',
          fixed: 'left',
          type: 'text',
          render: (h, params) => {
            return h('span', params.row.activityNo)
          }
        },
        {
          title: "活动名称",
          key: "activityName",
          fixed: 'left'
        },
        {
          title: "活动ID",
          key: "uuid",
          align: 'center',
        },
        {
          title: "活动开始时间",
          key: "activityBeginTime",
          render: (h, params) => {
            return h('span', params.row.activityBeginTime)
          },
        },
        {
          title: "活动结束时间",
          key: "activityEndTime",
          render: (h, params) => {
            return h('span', params.row.activityEndTime)
          },

        },
        {
          title: "活动状态",
          key: "activityStatus",
          render: (h, params) => {
            return h('span', this.activityStatussObj[params.row.activityStatus] || params.row.activityStatus)
          }

        },
        {
        title: "操作",
        key: "action",
        width: 300,
        align: 'center',
        fixed: 'right',
        render: (h, params) => {
          return h("div", [
            h(
              "Button",
              {
                props: {
                  type: "primary",
                  size: "small"
                },

                attrs: {
                  style: "margin-right: 10px"
                },
                on: {
                  click: () => {
                    this.$refs['editFormBox'].resetFields();

                     this.editForm = {
                        id: params.row.id,
                        activityName: params.row.activityName,
                        activityNo: params.row.activityNo,
                        activityBeginTime: params.row.activityBeginTime,
                        activityEndTime: params.row.activityEndTime,
                        activityStatus: params.row.activityStatus,
                        preReleaseCode: params.row.preReleaseCode,
                        uuid:params.row.uuid
                      }
                      this.editVisable = true
                  }
                }
              },
              "修改"
            ),
             h(
              "Button",
              {
                props: {
                  type: "primary",
                  size: "small"
                },

                attrs: {
                  style: "margin-right: 10px"
                },
                on: {
                  click: () => {
                    
                    sessionStorage['activityName']=params.row.activityName;
                    sessionStorage['activityId']=params.row.id;
                    window.sessionStorage.removeItem('sys');
										if(this.roles=='机构运营'){
											this.$router.push({path:'/myMessage/myMessage'});
										}else{
											this.$router.push({path:'/flowpath/index'});
										}
                  }
                }
              },
              "配置"
            ),
            h(
              "Button",
              {
                props: {
                  type: "primary",
                  size: "small"
                },
                attrs: {
                  style: "margin-right: 10px"
                },
                on: {
                  click: () => {
                    this.$hMessage.info({"duration":3,"content":"密钥：" + params.row.activitySecret});
                  }
                }
              },
              "查看密钥"
            ),
            h(
              "Button",
              {
                props: {
                  type: "error",
                  size: "small"
                },
                attrs: {
                  style: "margin-right: 10px"
                },
                on: {
                  click: () => {

                    this.$hMsgBox.confirm({
                      title: "提示",
                      content: "此操作将永久删除选择的活动,是否继续？",
                      onOk: () => {
                        this.removeUri(params.row.id);
                      },
                      onCancel: () => {}
                    });
                  }
                }
              },
              "删除"
            )
          ]);
        }
      }
      ];//列表
    return {
      showInput: false,
      roles:'',
      rolesArr:[],
      columns:columns,
      popshow:true,
      loading: false,
      editVisable: false,
      objectList:[],
      pageInfo:{
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      editForm: {
          id: '',
          activityName: '',
          activityNo: '',
          activityBeginTime: '',
          activityEndTime: '',
          activityStatus: '',
          preReleaseCode: '',
          uuid:'',
        },
        editRules: {
          activityName: [
            {validator:validateTName,trigger:'blur'}
          ],
          activityNo:[
            {validator:validateTKey,trigger:'blur'}
          ],
          preReleaseCode: [
            {validator:validatePreCode,trigger:'blur'}
          ],
          activityEndTime:[
            {validator:activityEndTimeCode,trigger:'blur'}
          ],
        },
      activityStatuss:[{value: '0', label: '活动未发布'}, {value: '1', label: '活动已发布'}, {value: '2',label: '活动下线'}, {value: '3', label: '活动暂停'}],
      activityStatussObj:{'0': '活动未发布', '1': '活动已发布', '2': '活动下线', '3': '活动暂停'},


      setPassForm: {
        oldPassword: '',
        newPassword: '',
        newPasswordCheck: ''
      },
      setPassword: false,
      submitLoading: true,
      locktime: this.LOCAL_CONFIG.LOCK_TIME,
       theme: this.LOCAL_CONFIG.THEME,
      sysName: this.LOCAL_CONFIG.SYS_NAME,
      appname: '',
      canPage: true,
      isComputed: false,
      appList: [{
          value: 'tip1',
          label: '搜索提示1'
        },
        {
          value: 'tip2',
          label: '搜索提示2'
        },
        {
          value: 'tip3',
          label: '搜索提示3'
        }
      ],
      allAppList: [],
      navWidth: 0,
      showMore: false,
      hideNavList: [],
      userName: ''
    }
  },
  components: {
    LockScreen,
    Topbar
  },
  
  computed: {
    ...mapGetters([
      'permission_routers',
      'menusRoot',
      'activeIndex'
    ]),
    hideNavListLength() {
      return this.hideNavList.length
    }
  },
  watch: {
    theme() {
      allToggleClass(document.getElementsByTagName('html')[0], this.theme)
    },
    setPassword(val) {
      if (!val) {
        this.$refs.setPassForm.resetFields()
      }
    },
    hideNavListLength(val) {
      if (val > 0) {
        this.showMore = true
      } else {
        this.showMore = false
      }
    }
  },
  methods: {
    //活动列表函数
    dataChange(n) {
        this.loading = true;
        let data = {
          pageNum: n,
          pageSize: this.pageInfo.pageSize,
        };
        queryActivity(data).then(res => {
          if (res.data.errcode == '0') {
            this.objectList = res.data.data.list || [];
            if(this.objectList.length>0){
              this.popshow=false;
            }
            this.pageInfo.total = res.data.data.total;
            this.pageInfo.pageNo = n;
          } else {
            this.$message({
              type: 'fail',
              message: res.data.errmsg
            })
          }
          this.loading = false;
        }).catch(error => {
          this.loading = false
        })
      },
    //提交按钮函数
    submitAddorEdit() {
        this.$refs['editFormBox'].validate((valid) => {
          if (valid) {

            if (this.editForm.id) {
               let data = {
                id: this.editForm.id,
                activityName: this.editForm.activityName.trim(),
                activityBeginTime: this.editForm.activityBeginTime ? formatDateTime(this.editForm.activityBeginTime) : '',
                activityEndTime: this.editForm.activityEndTime ? formatDateTime(this.editForm.activityEndTime) : '',
                uuid:this.editForm.uuid,
                activityNo:this.editForm.uuid,
                activityStatus: this.editForm.activityStatus,
              };
              this.modFun(data);
            } else {
               let data = {
                id: this.editForm.id,
                activityName: this.editForm.activityName.trim(),
                activityBeginTime: this.editForm.activityBeginTime ? formatDateTime(this.editForm.activityBeginTime) : '',
                activityEndTime: this.editForm.activityEndTime ? formatDateTime(this.editForm.activityEndTime) : '',
              };
              this.addFun(data);
            }

          }

        });

      },
      //新增函数
      addFun(param) {
        addActivity(param).then((res) => {
          if (res.data.errcode == '0') {
            this.$message({
              type: 'success',
              message: '新增成功'
            });
            this.editVisable = false;
            this.dataChange(1);
          } else {
            this.$message({
              type: 'fail',
              message: res.data.errmsg
            })

          }
          

        });
      },
      //修改函数
      modFun(param) {
        editActivity(param).then((res) => {
          if (res.data.errcode == '0') {
            this.$message({
              type: 'success',
              message: '修改成功'
            });
          this.editVisable = false;
          this.dataChange(1);
          } else {
            this.$message({
              type: 'fail',
              message: res.data.errmsg
            })

          }
          ;
          

        });

      },
    

      /*删除*/
       removeUri(param) {
        removeActivity({id: param}).then((res) => {

            if (res.data.errcode == '0') {
              this.$message({
                type: 'success',
                message: res.data.data.value
              });
              this.selection = {};
              this.dataChange(1);
            } else {
              this.$message({
                type: 'fail',
                message: res.data.errmsg
              })
            }
           
          }).catch((err) => {
            this.$message({
              type: 'error',
              message: err.message
            })
          })
    },

      onPageSizeChange(size) {
        this.pageInfo.pageSize = size;
        this.dataChange(1)
      },
      showadd() {
        this.$refs['editFormBox'].resetFields();
       
        this.editForm = {
          id: '',
          activityName: '',
          activityNo: '',
          activityBeginTime: '',
          activityEndTime: '',
          preReleaseCode: '',
          activityStatus: '',
        }
        this.editVisable = true
      },
    // 换肤
    handleChangeTheme(color) {
      this.theme = color
    },
    activeSidebar(index) {
      if (index >= 0) {
        this.$store.dispatch('ActiveRootIndex', index)
      }
      // let item = this.menusRoot[this.activeIndex]
      // 防止页面刷新时会跳转根页面
      // if(this.$route.matched[0].path !== item.url) {
      //   this.$router.push({path: item.url})
      // }
    },
   
    scroll(num) {
      let _this = this;
      if (num <= 1 && _this.canPage) {
        _this.canPage = false;
        let length = _this.appList.length;
        setTimeout(() => {
          let arr = _this.allAppList.slice(length, length + 10);
          if (arr.length > 0) {
            _this.appList = _this.appList.concat(arr);
            _this.canPage = true;
          } else {
            this.isComputed = true
          }
        }, 200);
      }
    },
    computedNavWidth() {
      this.hideNavList = []
      if (this.$refs.topbarNav) {
        let logoWidth = this.$refs.topbarLogo ? this.$refs.topbarLogo.clientWidth : 0
        let toolWidth = this.$refs.topbarTool ? this.$refs.topbarTool.clientWidth : 0
        let searchWidth = this.$refs.topbarSearch ? this.$refs.topbarSearch.clientWidth : 0
        this.navWidth = document.getElementsByClassName('h-topbar')[0].clientWidth - logoWidth - toolWidth - searchWidth - 20
        let that = this;
        this.$nextTick(function() {
          // 对nav menu子元素从后往前遍历，将超出部分保存至hideNavList
          // menu总长度 that.$refs.topbarNav.children[0].children.length === that.menusRoot.length
          let menuRootWidth = document.getElementsByClassName('h-topbar-navMenu')[0].clientWidth
          // menu子元素
          let menuChildren = document.getElementsByClassName('h-topbar-navMenu')[0].children
          if (menuChildren && menuChildren.length > 0 && that.navWidth < menuRootWidth) {
            for (let i = menuChildren.length - 1; i >= 0; i--) {
              if (that.navWidth < menuRootWidth) {
                that.hideNavList.splice(0, 0, that.menusRoot[i])
              } else {
                break
              }
              menuRootWidth = menuRootWidth - menuChildren[i].clientWidth
            }
          }
        })
      }
    },
   
  },
  created() {
    this.userName = sessionStorage['username']
    this.roles=sessionStorage['roles']?JSON.parse(sessionStorage['roles']):'';
    if(this.roles=="admin"){
      this.roles="管理员"
    }else if(this.roles=="isv"){
      this.roles="ISV"
    }else if(this.roles=="coper"){
      this.roles="机构运营"
    }else if(this.roles=="ooper"){
      this.roles="平台运营"
    }
    // 输入其他根目录下的路径时，切换sidebar
    if (this.menusRoot && this.menusRoot.length > 0) {
      if (this.$route.path.indexOf(this.menusRoot[this.activeIndex].url) < 0) {
        let urlArr = this.$route.path.split('/')
        let curUrl = '/' + urlArr[1]
        for (let [key, value] of this.menusRoot.entries()) {
          if (curUrl === value.url) {
            this.activeSidebar(key)
            return
          }
        }
      } else {
        // 更新对应的sidebar
        this.activeSidebar(this.activeIndex)
      }
    }
    //获取内部消息
    //initMsg();
    //setInterval(initMsg, 1000 * 60 * 5);// 5分钟轮询一次获取内部消息
  },
  mounted() {
    document.getElementsByTagName('html')[0].className = this.theme;
    this.computedNavWidth();
    document.addEventListener('resize', this.computedNavWidth());
     this.dataChange(1);
  }
}

</script>
<style scoped lang="scss">
.h-topbar{
  height: 64px;
}
.pT{
  color: #495060;
  background: #fff;
  text-align: left;
  padding-bottom: 0;
  margin-bottom: 10px;
  font-weight: normal;
}
.messageBox{
  background: #fff;
  padding:10px 30px;
}
.messageBoxc{
  border:1px solid #DCE1E7;
  padding:10px;
}
.messageBoxcV{
  overflow: hidden;
  margin-bottom: 10px;
}
.messageBoxcVL{
  float: left;
  width: 50%;
}
.messageBoxcVLc{
  overflow: hidden;
}
.messageBoxcVLcl{
  float: left; 
  width: 50px;
  height: 50px;
  border-radius: 100%;
}
.messageBoxcVLcl img{
  width: 50px;
  height: 50px;
  border-radius: 100%;
}
.messageBoxcVLcr{
  float: left;
  text-align: left;
  margin-left: 10px;
  height: 50px;
  // line-height: 50px;
}


.messageBoxcVR{
  float: left;
  width: 50%;
  background: blur;
  text-align: right;
  height: 50px;
  line-height: 50px;
}

</style>



// WEBPACK FOOTER //
// src/views/mainIndex.vue